import {
  Award,
  Gem,
  NotebookText,
  Rocket,
  SquareUserRound,
  Video,
} from "lucide-react";
import CallToAction from "./PaCallToAction";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PremiumAccess = () => {
  const features = [
    {
      icon: <Video />,
      label: "Connect with experts and mentors",
    },
    {
      icon: <img src="/PremiumAccess/PaWire.png" alt="wire" />,
      label: "Tailored roadmap from Class 9 to 12",
    },
    {
      icon: <NotebookText />,
      label: "Build your student portfolio",
    },
    {
      icon: <Gem />,
      label: "Access curated opportunities worldwide",
    },
    {
      icon: <SquareUserRound />,
      label: "STEM, Humanities, Arts & More",
    },
    {
      icon: <Rocket />,
      label: "Get recognized for your journey",
    },
    {
      icon: <Award />,
      label: "Learn, compete, and earn recognition",
    },
    // { icon: <Star />, label: "Many More", color: "bg-blue-50 border-blue-200" },
  ];
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="p-4">
      {/* Header */}
      <div className="bg-[#FCF5FF]  inline-flex items-center gap-2 mb-4 px-3 py-3 rounded-md  ">
        <div className="w-5 h-5  rounded flex items-center justify-center">
          <img src="/PremiumAccess/PaLock.svg" alt="Lock" />
        </div>
        <span className="font-inter text-[#572575] text-[#572575] font-bold text-[16px] leading-[100%] align-middle">
          Premium Access Required
        </span>
      </div>
      {/* <Button onClick={() => setOpen(true)}>TEST</Button>
      {open && <ProfessionalInfoForm onClose={() => setOpen(false)} />} */}

      {/*  Content */}
      <div className="space-y-8">
        {/* Main Heading */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <h1 className="font-inter font-bold text-2xl text-black  align-middle mb-4 flex items-center gap-2 flex-wrap">
              Don’t Miss Out — Enroll to Unlock!
            </h1>
            <button
              onClick={() => navigate("/sap/pricing-plan")}
              className="bg-[#5E2A84] hover:bg-[#532575] text-white text-[14px] font-semibold px-6 py-2 rounded-lg transition"
            >
              Get Personalized Timeline
            </button>
          </div>
          <p className="text-[#313439] text-lg font-inter leading-relaxed">
            This page is locked for you. Complete your enrollment and get
            instant access to all below features.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-3 gap-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center gap-1 rounded-lg border bg-[#F5F5F5] hover:shadow-sm transition-shadow p-1"
            >
              <div className="p-2 gap-1 flex items-center justify-center">
                <span className="text-[#572575] text-md">{feature.icon}</span>
                <span className="font-inter font-bold text-[12px] leading-[100%] align-middle text-[#3F424C] whitespace-nowrap text-center">
                  {feature.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom CTA Section */}
      <CallToAction />
    </div>
  );
};

export default PremiumAccess;
